'use strict';
var ansiRegex = require('ansi-regex')();

module.exports = function (str) {
	return typeof str === 'string' ? str.replace(ansiRegex, '') : str;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/strip-ansi/index.js
 ** module id = 1180
 ** module chunks = 0
 **/